import React from 'react';
import Paper from '@material-ui/core/Paper';
import urlBase from '../../../url-base';
import CircularProgress from '@material-ui/core/CircularProgress';
import Dialog from 'material-ui/Dialog';
import Grid from '@material-ui/core/Grid';
//import RaisedButton from 'material-ui/RaisedButton';
import TextField from 'material-ui/TextField';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import FlatButton from 'material-ui/FlatButton';
import InputMask from 'react-input-mask';
import { InputGroup, InputGroupAddon, Input, Button} from 'reactstrap';
import axios from 'axios';
import Checkbox from 'material-ui/Checkbox';
import { Styles, Colors, tableStyles } from '../../../styles/theme';
import { Col, Row} from 'reactstrap';

/* import ReactPaginate from 'react-paginate'; */


class SalesmanList extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      data: 'loading',
      id : '',
      name: '',
      email: '',
      password: '',
      image: urlBase.client+'/assets/images/icons/scan.png',
      cpf: '',
      active: '',
      phone: '',
      linkSite: '',
      IdCorretoraSelecionada : '',
      codeS4: '',
      brokerId:'',
      userId:'',
      salesmanList: [],
      chooseSalesmanSelect: 'null',
      tituloDialog: 'Novo',
      isExisteSalesman : false,
      typeInputPassword: 'password',
      isLinkSite:false,
      linkSiteAlterar:'',
      modalOpen: false,
      validCpf: false,
      salesmanS4: null,
      loadingCpf: false,
      loadingSave: false,
      success: null,
      pesquisaPorCpf: false,
      cpfPesquisa: '',      
      linkSiteError: {
        display: 'none',
        msg: ''
      },
      emailError: {
        display: 'none',
        msg: ''
      },

      listBroker: [],
      chooseBrokerSelect: 'null',

      editIndex: null,
      deleteIndex: null,
      editImage: false,

      modalDelete: false,
      modalDeleteOpen: false,
      modalDeleteLoading: false
    };
    this.userStatus = {
      true : 'ATIVO',
      false : 'INATIVO'
    };
    this.styles = {
      error: {
        textAlign: 'center',
        fontSize: 18,
        color:'#ea0000',
        background:'#fff',
        padding:10,
        borderRadius: 3,
        fontWeight: 500
      },
      zero: {
        textAlign: 'center',
        fontSize: 18,
        background:'#fff',
        padding:10,
        borderRadius: 3,
        fontWeight: 500
      },
      titleTable: {
        textAlign: 'center',
        padding: 0
      },
      modal: {
        width: '85%',
        maxWidth: 'none',
      },
      closeBtn: {
        float: 'right',
        width: 25,
        cursor: 'pointer',
        position: 'relative',
        bottom: 15,
        left: 5
      },
      inputs: {
        marginLeft: 10,
      },
      sendFormSuccess: {
        padding: 10,
        color: '#155724',
        backgroundColor: '#d4edda',
        borderColor: '#c3e6cb'
      },
      sendFormError: {
        padding: 10,
        color: '#721c24',
        backgroundColor: '#f8d7da',
        borderColor: '#f5c6cb'
      },
      eyePassword: {
        cursor: 'pointer',
        padding: 10,
        bottom: 0,
        top: 25,
        position: 'relative'
      }
    };

    // Campos obrigatórios
    this.errorField = {
      name: '',
      email: '',
      password: '',
      cpf: '',
      linkSite: '',
      codeS4: ''
    };

    this.errorFormat = {
      email: '',
    };
  }


  componentDidMount() {
    // Pega as corretoras
    axios.get(urlBase.loopBack + 'Brokers?filter={"include":"user"}')
    .then((result) => {
      const brokers = result.data;
      // 2. Ordene a lista pelo nome do usuário
      brokers.sort((a, b) => {
        // Usamos localeCompare para uma ordenação alfabética correta
        return a.user.name.localeCompare(b.user.name);
      });     
      this.setState({
        listBroker: brokers
      });
     // state.listBroker = result.data;
      //this.setState(state);
    })
    .catch(function (erro) {
      alert('Buscar Corretoras: ' + erro);
    });

  }

  getData(url) {
    $("#table_id").DataTable().destroy();
    axios.get(url)
    .then((response) => {
      let state = this.state;
      if (response.data.length == 0)
        state.data = 'zero';
      else 
        state.data = response.data;
        for (let i = 0; i < state.data.length; i++) {
          state.data[i].user.active = this.userStatus[state.data[i].user.active];
        }    

      this.setState(state);
      $(document).ready( function () {
        $('#table_id').DataTable({
          "language": {
            "url": urlBase.client + "assets/plugins/datatables/Portuguese-Brasil.lang"
          },
          "order": [[0, "desc"]],
          lengthMenu: [
            [10, 25, 50, 100, -1],
            ['10', '25', '50', 100, 'Todas']
          ]
        });
      });

    })
    .catch(function () {
      let state = this.state;
      state.data = 'error';
      this.setState(state);
    }.bind(this));
  }

  // Monitora mudanças a atualiza estados dos inputs text
  onChange(e) {
    let state = this.state;
    state[e.target.name] = e.target.value;

    if (e.target.value == '')
      this.errorField[e.target.name] = 'Campo obrigatório';
    else
      this.errorField[e.target.name] = '';

    this.setState(state);
  }

  onBlurField(e) {
    let state = this.state;
    state.emailError.display = 'none';
    state.emailError.msg = '';
    this.setState(state);

    if (e.target.type == 'email') {
      if (!e.target.validity.valid)
        this.errorFormat[e.target.name] = 'Formato esperado: email@exemplo.com';
      else {
        this.onBlurEmail(e);
        this.errorFormat[e.target.name] = '';
      }
    }
    else if (e.target.name == 'cpf')
      this.validateCpf(e.target.value);
  }

  validateCpf(cpf) {
    let state = this.state;
    let test = true;
    let add = 0, i = 0, rev = 0;
    let cpfExist = cpf;
    cpf = cpf.replace(/[^0-9]/g,'');

    if (cpf.length != 11 || 
        cpf == "00000000000" || 
        cpf == "11111111111" || 
        cpf == "22222222222" || 
        cpf == "33333333333" || 
        cpf == "44444444444" || 
        cpf == "55555555555" || 
        cpf == "66666666666" || 
        cpf == "77777777777" || 
        cpf == "88888888888" || 
        cpf == "99999999999") {
      test = false;
    }
    else {
      // Valida 1° digito	
      for (i=0; i < 9; i ++)		
        add += parseInt(cpf.charAt(i)) * (10 - i);	
        rev = 11 - (add % 11);	
        if (rev == 10 || rev == 11)
          rev = 0;

        if (rev != parseInt(cpf.charAt(9)))
          test = false;          	

      // Valida 2° digito	
      add = 0;	
      for (i = 0; i < 10; i ++)
        add += parseInt(cpf.charAt(i)) * (11 - i);

      rev = 11 - (add % 11);	

      if (rev == 10 || rev == 11)
        rev = 0;

      if (rev != parseInt(cpf.charAt(10)))
        test = false;
    }

    if (test == true) {
      this.errorField.cpf = '';
      if (state.tituloDialog == 'Novo')
         this.getExistSalesman(cpfExist);
      else 
         this.getSalesman(cpf);
    }
    else {
      this.errorField.cpf = 'CPF inválido';
      state.validCpf = false;
    }

    state.success = null;
    state.password = cpf.substring(0, 6);
    this.setState(state);
  }
  getExistSalesman(cpf) {
    
    let url = urlBase.loopBack + `Salesmans?filter={"where":{"cpf":"${cpf}"},"include":"user"}`;

    let state = this.state;
    state.isExisteSalesman = false;
    axios.get(url)
    .then((response) => {

      let salesmans = response.data; // Array retornado
      let salesmansAtivos = salesmans.filter(s => {
        // Ajuste o "status === 'active'" para a propriedade real que você usa para definir se está ativo
        return s.user && s.user.active === true; 
      });

      let totalAtivos = salesmansAtivos.length;    

      if (totalAtivos > 0) {
        state.validCpf = false;
        this.errorField.cpf = 'Já existe vendedor cadastrado com esse cpf';
        state.isExisteSalesman = true;
        this.setState(state);

      }
      else {
        this.getSalesman(cpf.replace(/[^0-9]/g,''));
      }


    })
    .catch(function () {
      this.errorField.cpf = 'Erro ao pesquisar CPF.';
      this.state.validCpf = false;
      this.state.loadingCpf = false;
    //  this.setState(state);

    }.bind(this));


  }  
  /*
  getExistSalesman(cpf) {
    
   // let url = urlBase.loopBack + 'Salesmans?filter={"where" : {"cpf":"' + cpf + '"}}';
    let url = urlBase.loopBack + 'Salesmans/count?where={"cpf":"'+cpf+'"}';
    let state = this.state;
    state.isExisteSalesman = false;
    axios.get(url)
    .then((response) => {

      if (response.data.count > 0) {
        state.validCpf = false;
        this.errorField.cpf = 'Já existe vendedor cadastrado com esse cpf';
        state.isExisteSalesman = true;
        this.setState(state);

      }
      else {
        this.getSalesman(cpf.replace(/[^0-9]/g,''));
      }


    })
    .catch(function () {
      this.errorField.cpf = 'Erro ao pesquisar CPF.';
      this.state.validCpf = false;
      this.state.loadingCpf = false;
    //  this.setState(state);

    }.bind(this));


  }
  */
  getSalesman(cpf) {
    let url = urlBase.loopBack + 'APIS4s/Vendedores';
    let dataPost = {
      'cpf': cpf
    };

    let state = this.state;
    state.validCpf = false;
    state.loadingCpf = true;
    this.setState(state);

    axios.post(url, dataPost)
    .then((response) => {
      let state = this.state;
      if (response.data.length > 0) {
        state.salesmanList = response.data;
        state.validCpf = true;
      }
      else {
        state.validCpf = false;
        this.errorField.cpf = 'Vendedor não localizado no sistema S4';
        state.codeS4 = '';
        state.name = '';
        state.salesmanS4 = null;
      }
      state.loadingCpf = false;
      this.setState(state);
      this.getLinkSite(this.state.linkSite, null);
    })
    .catch(function () {
      let state = this.state;
      this.errorField.cpf = 'Erro ao pesquisar CPF.';
      state.validCpf = false;
      state.loadingCpf = false;
      this.setState(state);
    }.bind(this));
  }

  fileToBase64(typeDoc) {
    let reader = new FileReader();
    let file = document.getElementById('doc_'+typeDoc).files[0];
    let state = this.state;

    state.editImage = true;
    document.getElementById('name_file_'+typeDoc).style.display = 'inherit';
    document.getElementById('name_file_'+typeDoc).src = window.URL.createObjectURL(file);

    reader.onloadend = function() {
      document.getElementById('imagem_'+typeDoc).value = reader.result;
    }.bind(this);
    reader.readAsDataURL(file);
  }

  addSalesman() {
    this.stateDefault();
    let state = this.state;
    state.isExisteSalesman = false;

    this.errorField.cpf = '';
    state.tituloDialog = 'Novo';
    state.brokerId = this.state.IdCorretoraSelecionada;
    state.modalOpen = true;
    state.success = null;
    this.setState(state);
  }

  sendSalesman () {    
    let state = this.state;
    state.loadingSave = true;
    this.setState(state);

    if (this.state.editIndex != null)
      this.sendEdit();
    else {
      let dataPost = {
        userId: this.state.chooseBrokerSelect,
        name: this.state.name,
        email: this.state.email,
        password: this.state.password,
        image: document.getElementById('imagem_image').value,
        cpf: this.state.cpf,
        phone: this.state.phone,
        linkSite: this.state.linkSite,
        codeS4: this.state.codeS4,
      };
      let url = urlBase.loopBack + '/Salesmans/saveUserSalesman';

      axios.post(url, dataPost)
      .then(() => {
        let state = this.state;
        state.loadingSave = false;
        state.success = true;
        this.setState(state);
        this.stateDefault();
      })
      .catch(function () {
        let state = this.state;
        this.errorField.cpf = 'Erro ao pesquisar CPF.';
        state.validCpf = false;
        state.loadingCpf = false;
        state.success = false;
        this.setState(state);
      }.bind(this));
    }
  }

  saveSalesman() {
    let state = this.state;

    let isNewPassword = false;

    let dataPost = [];
    if (state.tituloDialog === 'Alterar') {
      if (state.linkSiteAlterar != this.state.linkSite) {
        this.getLinkSite(this.state.linkSite);
        this.verificarSeLinkExiste(this.state.linkSite);
        if (  state.isLinkSite ) {
          alert("Link de vendas já existe");
          return;
        }        

      }
     
      dataPost = {
        id : this.state.id, 
        cpf : this.state.cpf,
        name: this.state.name,
        email: this.state.email,
        phone : this.state.phone,
        linkSite : this.state.linkSite,
        codeS4 : this.state.codeS4,
        password: this.state.password,
        userId : this.state.userId,   
        brokerId : this.state.brokerId,
        active: this.state.active,
        image: document.getElementById('name_file_image').value
      };        
    } else {
        this.verificarSeLinkExiste(this.state.linkSite);
        if (  state.isLinkSite ) {
          alert("Link de vendas já existe");
          return;
        }          
        if (this.state.password == '')
            isNewPassword = true;
        dataPost = {
          cpf : this.state.cpf,
          name: this.state.name,
          email: this.state.email,
          telefone : this.state.phone,
          linkSite : this.state.linkSite,
          codeS4 : this.state.codeS4,
          password: this.state.password,
          //Paulo - comentei aqui mas será preciso testar mais
          //userId : this.state.userId,   
          brokerId : this.state.brokerId,
          active: this.state.active,
        image: document.getElementById('name_file_image').value
      };        
    }  
   if (state.name.length != 0 &&
       state.cpf.length != 0 &&
       state.email.length != 0 &&
       state.codeS4.length != 0 &&
          !isNewPassword   ) {

      state.loadingSave = true;

      this.setState(state);

      let url = urlBase.loopBack + '/Salesmans/insertUpdateUserSalesman';

      axios.post(url, dataPost)
      .then(() => {

        let state = this.state;
        state.loadingSave = false;
        state.success = true;
        this.setState(state);
      // this.stateDefault();
      })
      .catch(function (error) {
        let state = this.state;
        state.success = false;
        state.loadingSave = false;
        if (error.message.indexOf("422") != -1) {
          state.emailError.msg = "E-mail já em uso por outro usuário.";
        }
        this.setState(state);        


      }.bind(this));
    }
    else {
        alert('Necessário preencher os campos obrigatórios de forma correta.');
        let state = this.state;
        state.emailError.msg = '';
        this.setState(this.state);

    }

  }

  stateDefault() {
    let state = this.state;

    state.chooseSalesmanSelect = 'null';
    state.name = '';
    state.id = '';
    state.email = '';
    state.password = '';
    state.image = urlBase.client+'/assets/images/icons/scan.png';
    state.cpf = '';
    state.phone = '';
    state.linkSite = '';
    state.codeS4 = '';
    state.validCpf = false;
    state.salesmanS4 = null;
    state.loadingCpf = false;
    state.loadingSave = false;
    state.linkSiteError = {
      display: 'none',
      msg: ''
    },
    state.emailError = {
      display: 'none',
      msg: ''
    };
    state.editIndex = null;
    state.deleteIndex = null;
    state.editImage = false;
    state.modalDelete = false;
    state.modalDeleteLoading = false;
  
    this.setState(state);
  }


  onChangeLinkSite(e) {
    let state = this.state;
    state.linkSite = e.target.value.replace(/[^a-z0-9_-]/gi,'').toLowerCase();
    this.setState(state);
  }

  verificarSeLinkExiste(linkSite) {
     let url = urlBase.loopBack + 'Salesmans/countLinkSite?where={"linkSite":"'+linkSite+'"}' ;
     axios.get(url)
     .then((response) => {
       let state = this.state;
       // Se encontrar pelo menos um vendedor ou mais com mesmo linkSIte
       if (response.data.count > 0) {
        state.isLinkSite = true;
       }
       else {
        state.isLinkSite = false;

       }
       this.setState(state);
     })
     .catch(function () {
       let state = this.state;
       state.linkSiteError.display = 'block';
       state.linkSiteError.msg = 'Erro ao verificar o Link de Vendas';
       this.setState(state);
     }.bind(this));
   }

  getLinkSite(linkSite, cb=null) {
   // let url = urlBase.loopBack + 'Salesmans/count?where={"linkSite":"'+linkSite+'"}';
   let url = urlBase.loopBack + 'Salesmans/countLinkSite?where={"linkSite":"'+linkSite+'", "cpf":"' + this.state.cpf +'"}' ;
   //let url = urlBase.loopBack + 'Salesmans/countLinkSite?where={"linkSite":"'+linkSite+'"}' ;
    axios.get(url)
    .then((response) => {
      let state = this.state;
      // Se encontrar pelo menos um vendedor ou mais com mesmo linkSIte
      if (response.data.count > 0) {
        state.linkSiteError.display = 'block';
        state.linkSiteError.msg = 'Link de vendas já em uso.';
        state.linkSite = "";
        state.isLinkSite = true;
      }
      else {
        state.linkSiteError.display = 'none';
        state.linkSiteError.msg = '';
        state.isLinkSite = false;


        if (cb != null)
          cb();
      }
      this.setState(state);
    })
    .catch(function () {
      let state = this.state;
      state.linkSiteError.display = 'block';
      state.linkSiteError.msg = 'Erro ao verificar o Link de Vendas';
      this.setState(state);
    }.bind(this));
  }

  onBlurLinkSite(e) {
    if (e.target.value.length > 0) {
      this.getLinkSite(e.target.value, null);
    }
  }

  onBlurEmail(e) {
    if (e.target.value.length > 0) {
     let url = '';
     
     if ( this.state.tituloDialog == 'Novo')
         url = urlBase.loopBack + 'Accounts/count?where={"email":"'+e.target.value+'"}'+'&access_token='+localStorage.getItem('dental_t');
     else     
        url = urlBase.loopBack + 'Accounts/countEmail?where={"email":"'+e.target.value+'", "id":"'+ this.state.userId+'"}'+'&access_token='+localStorage.getItem('dental_t');
      axios.get(url)
      .then((response) => {
        let state = this.state;

        // Se encontrar pelo menos um vendedor ou mais com mesmo email
        if (response.data.count > 0) {
          state.emailError.display = 'block';
          state.emailError.msg = 'Email já em uso.';
        }
        else {
          state.emailError.display = 'none';
          state.emailError.msg = '';
        }
        this.setState(state);
      })
      .catch(function () {
        let state = this.state;
        state.emailError.display = 'block';
        state.emailError.msg = 'Erro ao verificar o email';
        this.setState(state);
      }.bind(this));
    }
  }
  
  handleModalClose() {
    let state = this.state;
    state.editIndex = null;
    state.modalOpen = false;
    this.setState(state);
    this.stateDefault();
    this.getData(urlBase.loopBack + 'Salesmans/getSalesmanByUserId?userId='+this.state.chooseBrokerSelect);
  }

  edit(index) {
    let state = this.state;
    state.validCpf = true;
    state.isExisteSalesman = true;
    state.success = null;
    this.errorField.cpf = '';
   // state.editIndex = index;
    state.tituloDialog = 'Alterar';
   // this.getSalesman(state.data[index].cpf.match(/\d/g).join(""));
    state.id = state.data[index].id;
    state.name = state.data[index].user.name;
    state.userId =state.data[index].user.id;
    state.email = state.data[index].user.email;
    state.image = urlBase.loopBack + 'attachments/users/download/' + state.data[index].user.image;
    state.password = '';
    state.active = (state.data[index].user.active === 'ATIVO' ? true : false);
    state.brokerId = state.data[index].brokerId;
    state.cpf = state.data[index].cpf;
    state.phone = state.data[index].phone;
    state.linkSite = state.data[index].linkSite;
    state.linkSiteAlterar = state.linkSite;
    state.codeS4 = state.data[index].codeS4;
    state.modalOpen = true;
    this.setState(state);
  }

  sendEdit() {
    let dataPost = {
      phone: this.state.phone,
      linkSite: this.state.linkSite
    };

    axios.post(urlBase.loopBack + 'Salesmans/upsertWithWhere?where={"id":"'+this.state.data[this.state.editIndex].id+'"}', dataPost)
    .then(() => {
      let dataPostUser = {
        id: this.state.data[this.state.editIndex].user.id,
        email: this.state.email
      };

      if (this.state.password.length > 0)
        dataPostUser.password = this.state.password;
      if (this.state.editImage == true && document.getElementById('imagem_image').value.length > 0)
        dataPostUser.image = document.getElementById('imagem_image').value;

      axios.post(urlBase.loopBack + 'Accounts/saveUserImage', dataPostUser)
      .then(() => {
        let state = this.state;

        state.loadingSave = false;
        this.setState(state);
        this.stateDefault();
        this.handleModalClose();
      })
      .catch(function (error) {
        alert('Erro ao editar vendedor: ', error);
      }.bind(this));
    })
    .catch(function (error) {
      alert('Erro ao editar vendedor: ', error);
    }.bind(this));
  }
  localizarSalesman () {
const { pesquisaPorCpf, cpfPesquisa, chooseBrokerSelect } = this.state;
    if (pesquisaPorCpf) {
        if (!cpfPesquisa) {
          alert("Por favor, digite um CPF.");
          return;
        }
        this.setState({ chooseBrokerSelect: 'null' });
        console.log("Pesquisando por CPF:", cpfPesquisa);
        // Aqui vai sua lógica de API para o CPF
        const filter = JSON.stringify({
          where: { cpf: cpfPesquisa },
          include: "user"
        });
        this.getData(`${urlBase.loopBack}Salesmans?filter=${filter}`);            
      } else {
        if (!chooseBrokerSelect || chooseBrokerSelect === "null") {
          alert("Por favor, selecione uma corretora.");
          return;
        }
        console.log("Pesquisando por Corretora ID:", chooseBrokerSelect);
        // Aqui vai sua lógica de API para a Corretora
        
    }    

  }
    
  // Monitora mudanças a atualiza estados do Select 'Corretora'
  brokerChange(event, index, payload) {
    let state = this.state;
    state.chooseBrokerSelect = payload;
    let broker = state.listBroker[index-1];
    state.IdCorretoraSelecionada = broker.id;
    this.setState(state);
    this.getData(urlBase.loopBack + 'Salesmans/getSalesmanByUserId?userId='+payload);

  }

  eyePasswordClick(type) {
    let state = this.state;
    state.typeInputPassword = type;
    this.setState(state);
  }

  handleModalDeleteOpen(index) {
    let state = this.state;
    state.deleteIndex = index;
    state.modalDeleteOpen = true;
    this.setState(state);
  }

  handleModalDeleteClose() {
    this.setState({modalDeleteOpen: false});
    this.getData(urlBase.loopBack + 'Salesmans/getSalesmanByUserId?userId='+this.state.chooseBrokerSelect);
  }

  sendDelete() {
    let state = this.state;
    state.modalDelete = true;
    state.modalDeleteLoading = true;
    this.setState(state);

    /* let dataSumit = this.state.data[this.state.deleteIndex];
    dataSumit.active = false; 

    let dataSumit = {
      userId: 
    };*/

    axios.get(
      urlBase.loopBack + 'Salesmans/'+this.state.data[this.state.deleteIndex].id+'?filter={"include":"user"}'
    )
    .then((result) => {
      let dataSumit = {
        userId: result.data.user.id
      };

      axios.post(
        urlBase.loopBack + 'Accounts/disableUser?access_token='+localStorage.getItem('dental_t'),
        dataSumit
      )
      .then(() => {
        let state = this.state;
        state.modalDelete = false;
        state.modalDeleteLoading = false;
        this.setState(state);
        this.handleModalDeleteClose();
      })
      .catch(function (error) {
        alert('Erro ao deletar vendedor: ', error);
      }.bind(this));
    })
    .catch(function (error) {
      alert('Erro ao deletar vendedor: ', error);
    }.bind(this));
  }
  
  handleChange(e, _name, event, index, _value){
    let state = this.state;
    state.active = _value;
    this.setState(state); 
  }

    // Monitora mudanças a atualiza estados do Select 'Corretora'
 brokerChangeSelect(event, index, brokerId) {
      let state = this.state;
      state.brokerId = brokerId;
      this.setState(state);
  
  }
  
  // Monitora mudanças a atualiza estados do Select 'Vendedores'
  salesmanChange(event, index, payload) {
    let state = this.state;
    state.chooseSalesmanSelect = payload;

    if (payload != 'null') {
      let nameArray = state.salesmanList[index-1].Nome.split(' - ')[1].trim().toLowerCase().split(' ');
      state.validCpf = true;
      this.errorField.cpf = '';
      state.codeS4 = state.salesmanList[index-1].Id;
      state.name = state.salesmanList[index-1].Nome;
      state.linkSite = nameArray[0] + '-' + nameArray[nameArray.length -1 ];
    }

    /*  */
    this.setState(state);
  }


  render() {

    return (
      <div>
        <style>{tableStyles}</style>


        {/** vendo  */}
        <Paper
          style={{
            padding: '20px 24px',
            marginTop: 16,
            borderRadius: 8,
            border: '1px solid #c1c3c6',
            boxShadow: 'none'
          }}
        >

          {/* Título */}
          <div style={{ marginBottom: 16 }}>
            <h3 style={{ margin: 0, fontSize: 16, fontWeight: 600 }}>
              🔎 Filtros de Pesquisa
            </h3>
            <span style={{ fontSize: 13, color: '#6B7280' }}>
              Selecione uma corretora ou pesquise diretamente por CPF
            </span>
          </div>

        <Row style={{ alignItems: 'center' }}>

          {/* Checkbox */}
          <Col xs="12" md="2" lg="2">
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <Checkbox
                checked={this.state.pesquisaPorCpf}
                onCheck={(e, isChecked) =>
                  this.setState({ pesquisaPorCpf: isChecked })
                }
                iconStyle={{ fill: '#000' }}
              />
              <span style={{ fontSize: 13, whiteSpace: 'nowrap' }}>
                Pesquisar por CPF
              </span>
            </div>
          </Col>

          {/* CPF */}
          <Col xs="12" md="3" lg="3">
            <TextField
              floatingLabelText="Informe o CPF"
              fullWidth
              disabled={!this.state.pesquisaPorCpf}
            >
              <InputMask
                mask="999.999.999-99"
                maskChar={null}
                value={this.state.cpfPesquisa || ''}
                onChange={(e) =>
                  this.setState({ cpfPesquisa: e.target.value })
                }
                type="tel"
              />
            </TextField>
          </Col>

          {/* Corretora */}
          <Col xs="12" md="3" lg="3">
            <SelectField
              fullWidth
              floatingLabelText="Corretora"
              disabled={this.state.pesquisaPorCpf}
              value={this.state.chooseBrokerSelect}
              onChange={this.brokerChange.bind(this)}
            >
              <MenuItem value={null} primaryText="Escolha uma corretora" />
              {this.state.listBroker &&
                this.state.listBroker.map(function (item, index) {
                  return (
                    <MenuItem
                      key={index}
                      value={item.user.id}
                      primaryText={item.user.name}
                    />
                  );
                })}
            </SelectField>
          </Col>

          {/* Botão */}
          <Col xs="12" md="2" lg="2">
            <div style={{ marginTop: 32 }}>
              <Button
                variant="contained"
                color="primary"
                fullWidth
                style={{
                  ...Styles.buttonCancel, backgroundColor: Colors.textLight,
                  textTransform: 'none',
                  fontWeight: 'bold'
                }}
                onClick={this.localizarSalesman.bind(this)}
              >
                Pesquisar
              </Button>
            </div>
          </Col>

        </Row>

        </Paper>  

          {/* Pesquisa 

          {/* CABEÇALHO DA PÁGINA COM BOTÃO ADICIONAR */}
          {
          (this.state.data !== 'loading' && this.state.data !== 'zero' && this.state.data !== 'error') ? (
          
''
          ) : ('')
          }       
                 <div style={{ 
            display: 'flex', 
            justifyContent: 'space-between', 
            alignItems: 'center', 
            marginBottom: '30px',
            marginTop: '20px',

            paddingLeft: '10px' 
          }}>
            <h2 style={{ 
              margin: 0, 
              fontSize: '1.4rem', 
              color: Colors.textDark, 
              fontWeight: 500,
              textTransform: 'uppercase' 
            }}>
            </h2>
            <Button
              variant="contained"
              color="primary"
              fullWidth
              style={{ ...Styles.buttonSuccess, textTransform: 'none', fontWeight: 'bold' }}
              onClick={this.addSalesman.bind(this)}
            >
              Novo Vendedor
          </Button>        

          </div>  
        {  (this.state.data !== 'loading' && this.state.data !== 'zero' && this.state.data !== 'error') ? (
            this.state.data == 'loading' ? (
              <div style={{textAlign: 'center'}}>
                <CircularProgress />
                <p>Carregando...</p>
              </div>
                ) : (
                  this.state.data == 'error' ? (
              <p style={this.styles.error}>
                Erro ao buscar dados.
              </p>
                  ) : (
                    this.state.data == 'zero' ? (
              <div style={this.styles.zero}>
                <p>Nenhuma vendedor encontrado.</p>
              </div>
                    ) : (
              <div>
                <Paper style={{  marginLeft: 10, borderRadius:10}}>
                  <table id="table_id" className="mdl-data-table table-striped" style={{width:'100%'}}>
                    <thead>
                      <tr>
                        <th style={{width:'50%'}}>Nome</th>
                        <th style={{width:'5%'}}>Cod. S4</th>
                        <th style={{width:'10%'}}>CPF</th>
                        <th style={{width:'10%'}}>Telefone</th>
                        <th >E-mail</th>
                        <th style={{width:'5%'}}>Status</th>
                        <th style={{width:'5%'}}>Ações</th>
                      </tr>
                    </thead>
                    <tbody>
                    {this.state.data.map((item, index) =>
                      <tr style={item.user.active == 'ATIVO' ? ( {padding:0}) : ({padding:0, color: 'rgb(244, 67, 54)'})}
                        id={'row_sales_'+item.salesId}
                        key={index}
                        className="row_table"
                      >
                        <td data-label="Nome" >{item.user.name}</td>
                        <td data-label="Cod. S4">{item.codeS4}</td>
                        <td data-label="cpf">{item.cpf}</td>
                        <td data-label="Telefone">{item.phone}</td>
                        <td data-label="E-mail">{item.user.email}</td>
                        <td data-label="Status">
                                  <span style={{
                                    padding: '4px 8px',
                                    borderRadius: '12px',
                                    fontSize: '10px',
                                    fontWeight: 'bold',
                                    backgroundColor: item.user.active == 'ATIVO' ? Colors.statusAtivoBg : Colors.statusInativoBg,
                                    color: item.user.active == 'ATIVO' ? Colors.statusAtivoText : Colors.statusInativoText
                                  }}>
                                    {item.user.active}
                                  </span>
                        </td>                         

                          <td>
                            <span 
                              onClick={this.edit.bind(this, index)}
                              style={{padding:0,cursor:'pointer'}}
                            >
                              <i className="fas fa-pen">{''}</i>
                            </span>
                          </td>
                      </tr>
                    )}
                    </tbody>

                  </table>
                </Paper>
      
              </div>
                )
              )
            )
          ) : ('')
        }


          
        <Dialog
          title={
            <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              padding: '16px 24px',
              backgroundColor: Colors.backgroundLight,
              borderBottom: `1px solid ${Colors.borderLight}`,
              borderRadius: '8px 8px 0 0'
            }}>
              <span style={{ fontSize: '1.2rem', fontWeight: 600, color: Colors.textDark, textTransform: 'uppercase' }}>
                {this.state.tituloDialog} Vendedor
              </span>
              <img
                style={{ cursor: 'pointer', width: '16px', opacity: 0.5 }}
                src={urlBase.client + '/assets/images/icons/icon_close.png'}
                onClick={this.handleModalClose.bind(this)}
                
              />
            </div>
          }
            titleStyle={{ padding: 0 }}
            bodyStyle={{ padding: '24px' }}
            modal={false}
            open={this.state.modalOpen}
            onRequestClose={this.handleModalClose.bind(this)}
            autoScrollBodyContent={true}
            contentStyle={{ width: '90%', maxWidth: '900px', borderRadius: '8px', overflow: 'hidden' }}
          >

          <div>
            <input id="imagem_image" type="hidden"/>
            {/* Mensagem de retorno do formulário */
              this.state.success != null ? (
                this.state.success == true ? (/* Formulário salvo com sucesso */
              <Grid container spacing={24} style={{marginTop:30}}>
                <Grid item xs={12} sm={12} md={12} lg={12}>
                  <div style={{textAlign: 'center'}}>
                    <p style={this.styles.sendFormSuccess}>Vendedor salvo com sucesso</p>
                  </div>
                </Grid>
              </Grid>
                ) : (/* Erro ao enviar formulário */
              <Grid container spacing={24} style={{marginTop:30}}>
                <Grid item xs={12} sm={12} md={12} lg={12}>
                  <div style={{textAlign: 'center'}}>
                    <p style={this.styles.sendFormError}>Erro ao salvar vendedor</p>
                  </div>
                </Grid>
              </Grid>
                )
              ) : ('')
            }

            {/* Loading de salvar o formulário*/
              this.state.loadingSave == true ? (
            <div id="loading_form">
              <Grid container spacing={24} style={{marginTop:30}}>
                <Grid item xs={12} sm={12} md={12} lg={12}>
                  <div style={{textAlign: 'center'}}>
                    <CircularProgress />
                    <p>Enviando...</p>
                  </div>
                </Grid>
              </Grid>
            </div>
              ) : (/* Formulário*/
            <div id="form">
              <Grid container spacing={24}>
                <Grid item xs={12} sm={12} md={4} lg={2}>
                  <TextField
                    errorText={this.errorField.cpf}
                    style={this.styles.inputs}
                    hintText="CPF"
                    floatingLabelText="CPF *"
                    type="text"
                    name="cpf"
                    value={this.state.cpf}
                    fullWidth={true}
                    onChange={(e) => this.onChange(e)}
                    onBlur={(e) => this.onBlurField(e)}
                  >
                    <InputMask
                      mask="999.999.999-99" maskChar=" " name="cpf" value={this.state.cpf}
                      />
                  </TextField>
                </Grid>

                {
                  this.state.loadingCpf == true ? (
                <Grid item xs={12} sm={12} md={2} lg={2}>
                  <div style={{textAlign: 'center'}}>
                    <CircularProgress />
                    <p>Pesquisando...</p>
                  </div>
                </Grid>
                  ) : ('')
                }

                {
                  this.state.validCpf == true ? (
                <Grid item xs={12} sm={12} md={8} lg={5}>
                  <SelectField
                    style={this.styles.input}
                    floatingLabelText="Vendedor S4 *"
                    fullWidth={true}
                    name="type"
                    value={this.state.chooseSalesmanSelect}
                    onChange={this.salesmanChange.bind(this)}
                  >
                    <MenuItem value="null" primaryText="Escolha um vendedor a partir do S4" />
                  {this.state.salesmanList.map((item, index) =>
                    <MenuItem key={index} value={item.Id} primaryText={item.Nome} />
                  )}

                  </SelectField>
                </Grid>

                  ) : ('')
                }
                {
                  this.state.validCpf == true ? (
                <Grid item xs={12} sm={12} md={6} lg={5}>
                  <TextField
                    style={this.styles.inputs}
                    hintText="Nome"
                    floatingLabelText="Nome"
                    type="text"
                    name="nome"
                    value={this.state.name}
                    fullWidth={true}
                  />

                </Grid>
                  ) : ('')
                }             
              {
                  this.state.validCpf == true ? (
                <Grid item xs={12} sm={12} md={6} lg={2}>
                  <TextField
                    style={this.styles.inputs}
                    hintText="Códito S4"
                    floatingLabelText="Código S4*"
                    type="text"
                    name="codigoS4"
                    value={this.state.codeS4}
                    fullWidth={true}
                  />

                </Grid>
                  ) : ('')
                }                
              {
                 this.state.validCpf == true ? (
                <Grid item xs={12} sm={8} md={6} lg={5}>
                  <SelectField
                    style={this.styles.input}
                    floatingLabelText="Corretora *"
                    fullWidth={true}
                    name="corretoraVendedor"
                    value={this.state.brokerId}
                    onChange={this.brokerChangeSelect.bind(this)}
                  >
                  {this.state.listBroker.map((item, index) =>
                    <MenuItem key={index} value={item.id} primaryText={item.user.name} />
                  )}

                  </SelectField>
                </Grid>
                ) : ('')
                }
                {
                  this.state.validCpf == true ? (
                <Grid item xs={12} sm={12} md={6} lg={5}>
                  <TextField
                    style={this.styles.inputs}
                    hintText="Telefone"
                    floatingLabelText="Telefone"
                    type="text"
                    name="phone"
                    value={this.state.phone}
                    fullWidth={true}
                    onChange={(e) => this.onChange(e)}
                    onBlur={(e) => this.onBlurField(e)}
                  >
                    <InputMask
                      mask="99 \9 9999-9999" maskChar=" " name="phone" value={this.state.phone}
                    />
                  </TextField>
                </Grid>

                  ) : ('')
                }
                {
                  this.state.validCpf == true ? (
                <Grid item xs={12} sm={12} md={6} lg={7}>
                  <TextField
                    errorText={this.errorFormat.email}
                    style={this.styles.inputs}
                    hintText="E-mail"
                    floatingLabelText="E-mail *"
                    type="email"
                    name="email"
                    value={this.state.email}
                    fullWidth={true}
                    onChange={(e) => this.onChange(e)}
                    onBlur={(e) => this.onBlurField(e)}
                  />
                  <p style={{
                    paddingLeft: 10,
                    color: 'rgb(244, 67, 54)',
                    fontSize: 12,
                    margin:0,
                    display: this.state.emailError.display}}
                  >
                    {this.state.emailError.msg}
                  </p>
                </Grid>
                  ) : ('')
                }

                {
                  this.state.validCpf == true ? (
                <Grid item xs={12} sm={12} md={6} lg={3}>
                  <Grid container spacing={24}>
                    <Grid item xs={10} sm={10} md={10} lg={10}>
                      <TextField
                        errorText={this.errorField.password}
                        style={this.styles.inputs}
                        hintText="Senha"
                        floatingLabelText="Senha *"
                        type={this.state.typeInputPassword}
                        name="password"
                        value={this.state.password}
                        fullWidth={true}
                        onChange={(e) => this.onChange(e)}
                      />
                    </Grid>
                    <Grid item xs={2} sm={2} md={2} lg={2} style={{textAlign:'center'}}>
                      {
                        this.state.typeInputPassword == "password" ? (
                      <i
                        style={this.styles.eyePassword}
                        className="far fa-eye"
                        onClick={this.eyePasswordClick.bind(this, 'text')}
                      >
                          {''}
                      </i>
                        ) : (
                      <i
                        style={this.styles.eyePassword}
                        className="far fa-eye-slash"
                        onClick={this.eyePasswordClick.bind(this, 'password')}
                      >
                        {''}
                      </i>
                        )
                      }
                    </Grid>
                  </Grid>
                </Grid>
                  ) : ('')
                }
              {
                                this.state.validCpf == true ? (
              <Grid item xs={12} sm={12} md={12} lg={2}>
                        <SelectField
                        floatingLabelText="STATUS *"
                        fullWidth={true}
                        name="status"
                        value={this.state.active}
                        onChange={this.handleChange.bind(this, null, 'status')}                      >
                        <MenuItem value={true} label={"ATIVO"}  primaryText={"ATIVO"} />
                        <MenuItem value={false} label={"INATIVO"}  primaryText={"INATIVO"} />
                      </SelectField>
                  </Grid>

                  ) : ('')
                }  


                {
                  this.state.validCpf == true ? (
                <Grid item xs={12} sm={12} md={6} lg={6} style={{textAlign: 'center'}}>
                  <label htmlFor="doc_image" style={{cursor:'pointer'}}>
                    Foto<br /><br />
                    <img
                      id="name_file_image"
                      src={this.state.image}
                      width="85"
                    />
                  </label>
                  <input
                    id="doc_image"
                    style={{visibility:"hidden",position:'absolute',left: -9999}}
                    type="file"
                    name="image"
                    onChange={this.fileToBase64.bind(this, 'image')}
                  />
                </Grid>
                  ) : ('')
                }

                {
                  this.state.validCpf == true ? (
                <Grid item xs={12} sm={12} md={12} lg={12}>
                  <label style={{paddingLeft: 10}}>Link de Vendas</label>
                  <InputGroup style={{paddingLeft: 10}}>
                    <InputGroupAddon addonType="prepend">{urlBase.client}</InputGroupAddon>
                    <Input
                      placeholder="Link de Vendas"
                      type="text"
                      name="linkSite"
                      value={this.state.linkSite}
                      onChange={(e) => this.onChangeLinkSite(e)}
                      onBlur={(e) => this.onBlurLinkSite(e)}
                    />
                  </InputGroup>
                  <p style={{
                    paddingLeft: 10,
                    color: 'rgb(244, 67, 54)',
                    fontSize: 12,
                    margin:0,
                    display: this.state.linkSiteError.display}}
                  >
                    {this.state.linkSiteError.msg}
                  </p>
                  <span style={{paddingLeft: 10}}>
                    Apenas letras números, hífen (-) e underline (_)
                  </span>
                </Grid>
                  ) : ('')
                }

              </Grid>

              {/* --- RODAPÉ DE AÇÕES --- */}
              <div style={{ marginTop: '40px', display: 'flex', justifyContent: 'flex-end', gap: '15px', borderTop: `1px solid ${Colors.borderLight}`, paddingTop: '20px' }}>
                <button
                  type="button"
                  onClick={this.handleModalClose.bind(this)}
                  style={{ ...Styles.buttonCancel, backgroundColor: '#999' }}
                >
                  CANCELAR
                </button>
                {this.state.validCpf && (
                  <button
                    type="button"
                    onClick={this.saveSalesman.bind(this)}
                    style={{ ...Styles.buttonSuccess, fontWeight: 'bold' }}
                  >
                    SALVAR VENDEDOR
                  </button>
                )}
              </div>

            </div>
              )
            /*#form*/}

          </div>
        </Dialog>

        <Dialog
          title="Confirmação"
          actions={
            [
              <FlatButton
                key={0}
                label="Não"
                primary={true}
                disabled={this.state.modalDelete}
                onTouchTap={this.handleModalDeleteClose.bind(this)}
              />,
              <FlatButton
                key={1}
                label="Sim"
                primary={true}
                disabled={this.state.modalDelete}
                onTouchTap={this.sendDelete.bind(this)}
              />
            ]
          }
          modal={true}
          open={this.state.modalDeleteOpen}
        >
          {
            this.state.modalDeleteLoading == true ? (
          <div style={{textAlign: 'center'}}>
            <CircularProgress />
            <p>Carregando...</p>
          </div>
            ) : ('Tem certeza que deseja excluir este(a) vendedor(a)?')
          }
        </Dialog>
      </div>
    );

  }

}

export default SalesmanList;



/** WEBPACK FOOTER **
 ** ./src/components/Panel/Salesmans/SalesmanList.js
 **/